import { render, staticRenderFns } from "./EditTarget.vue?vue&type=template&id=45075f6a&scoped=true"
import script from "./EditTarget.vue?vue&type=script&lang=js"
export * from "./EditTarget.vue?vue&type=script&lang=js"
import style0 from "./EditTarget.vue?vue&type=style&index=0&id=45075f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45075f6a",
  null
  
)

export default component.exports